import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { addPackagingData } from '../../../actions/package';
import { addStaff } from '../../../actions/staff';
import PackageApi from '../../../API/shipment/package-api';
import UserApi from '../../../API/user/user-api';
import qr from '../../../assets/media/icons/qr-code-scan.svg';
import { Column, Row } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import AccessSkladPopUp from '../../../components/Settings/PopUps/AccessSklad';
import { ALL_USERS, TO_PROFILE, TYPE_BUTTONS } from '../../../constans';
import { NAVIGATION } from '../../../routers/routes';
import CreateUserPackagerPopUp from './PopUps/CreateUserPackager';
import styles from './styles.module.scss';

const width = ['40px', '180px', '80px', '150px', '500px', '500px', '470px', '550px'];

function UsersPage() {
  const dispatch = useDispatch();
  const [popUp, setPopUp] = useState(false);

  const [popUpAccessSklad, setAccessSkladPopUp] = useState({ show: false, user: {} });

  const [popUpAccessContent, setAccessContentPopUp] = useState({ show: false, user: {} });

  const [popUpMethod, setMethodsPopUp] = useState(false);

  const staff = useSelector((store) => store.staff);
  const user = useSelector((store) => store.user);
  const methods = useSelector((store) => store.packaging);

  const getMethods = () => {
    PackageApi.getAll({}).then(r => dispatch(addPackagingData(r.data)));
  };
  useEffect(() => {
    UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
    getMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const packer = staff.filter((user) => user.role === 'packer');
  const sorter = staff.filter((user) => user.role === 'sorter');

  const sorted = [...packer, ...sorter].filter(user => !user.archive?.status);

  return (
    <>
      <Content>
        <Row style={{ alignItems: 'flex-start' }}>
          <Column>
            <H1>Сотрудники склада</H1>
            <Button type={TYPE_BUTTONS.BLUE} style={{ marginBottom: '20px' }} onClick={() => setPopUp(true)}>
              Добавить нового сотрудника
            </Button>
            <Table style={{ width: '1600px' }}>
              <TableHeader whiteHeader={true}>
                <HeaderTitle width={width[0]}>№</HeaderTitle>
                <HeaderTitle width={width[1]}>Логин</HeaderTitle>
                <HeaderTitle width={width[3]} centerText>
                  Роль
                </HeaderTitle>
                <HeaderTitle width={width[2]} centerText>
                  Scanner Id
                </HeaderTitle>
                <HeaderTitle width={width[4]}>Доступы</HeaderTitle>
                <HeaderTitle width={width[6]}>Настройка доступов</HeaderTitle>
                <HeaderTitle width={width[5]} rightText />
              </TableHeader>
              {sorted.map((item, key) => (
                <TableLine key={key}>
                  <TableCell width={width[0]}>{key + 1}</TableCell>
                  <TableCell width={width[1]}>
                    <Column>
                      <Link to={TO_PROFILE(item._id)} className={styles.link}>
                        <div style={{ fontWeight: '600' }}>{item.name}</div>
                      </Link>

                      <TextGrey>{item.login}</TextGrey>
                    </Column>
                  </TableCell>
                  <TableCell width={width[3]} center>
                    <div
                      className={cn(
                        styles.status,
                        ALL_USERS[item.role].name === ALL_USERS.owner.name && styles.sold,
                        ALL_USERS[item.role].name === ALL_USERS.admin.name && styles.sorted,
                        ALL_USERS[item.role].name === ALL_USERS.user.name && styles.pickup,
                        ALL_USERS[item.role].name === ALL_USERS.packer.name && styles.canceled_by_client,
                        ALL_USERS[item.role].name === ALL_USERS.sorter.name && styles.sorted,
                        ALL_USERS[item.role].name === ALL_USERS.content.name && styles.content,
                        ALL_USERS[item.role].name === ALL_USERS.booker.name && styles.booker,
                      )}
                    >
                      {ALL_USERS[item.role].name}
                    </div>
                  </TableCell>
                  <TableCell width={width[2]} center>
                    {item.scanerId}
                  </TableCell>

                  <TableCell width={width[4]}>
                    <Text style={{ overflowWrap: 'anywhere' }}>
                      {
                        Object.entries(item.accesses || {})
                          .reduce((acc, [serviceName, accessesByService]) => {
                            Object.entries(accessesByService).forEach(([access, hasAccess]) => { if (hasAccess) acc.push(NAVIGATION?.[serviceName]?.routes.find(r => r.path === access)?.name) })
                            return acc
                          }, []).join(', ')
                      }
                    </Text>
                  </TableCell>
                  <TableCell width={width[6]} style={{ alignItems: 'center' }}>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginRight: '10px' }}
                      onClick={() => setAccessSkladPopUp({ show: true, user: item })}
                    >
                      Доступы склада
                    </Button>

                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={async () => {
                        await UserApi.getAuthBarcode({ data: { login: item.login }, options: { download: true } })
                      }}
                      style={{ padding: 0, marginRight: '15px' }}
                    >
                      <Icon src={qr} width="35px" />
                    </Button>
                  </TableCell>
                  <TableCell width={width[4]} style={{ alignItems: 'center' }}></TableCell>
                </TableLine>
              ))}
            </Table>
          </Column>
        </Row>
      </Content>
      {popUp && <CreateUserPackagerPopUp close={() => setPopUp(false)} />}

      {popUpAccessSklad.show && (
        <AccessSkladPopUp user={popUpAccessSklad.user} close={() => setAccessSkladPopUp({ show: false, user: {} })} />
      )}
    </>
  );
}

export default UsersPage;
